<template lang="html">
  <div id="app-bar" class="w-100">
    <div id="app-bar-content"
      class="container-fluid
      d-flex align-items-center justify-content-between"
    >
      <div class="d-flex align-items-center">
        <button type="button"
          class="ml-2 ml-md-3 btn-menu btn btn-link-action"
          v-if="isTouchscreen"
          @click="setMenuActive(!menuActive)">
          <i class="fal fa-bars"></i>
        </button>
        <img id="app-bar-logo" class="ml-2 ml-md-3 py-2" src="/static/img/nav/nav-logo.png"
        @click="setMenuActive(!menuActive)" />
        <!-- <div v-if="isLoggedIn && !forPublic"
        class="user-name d-none d-md-block ml-2 pl-2">
          {{ userName }}
        </div> -->
      </div>
      <div class="app-bar-right
      d-flex align-items-center align-self-center">
        <div v-if="isLoggedIn && !forPublic" class="d-none d-md-block">
          <button class="btn btn-action btn-logout"
          @click="logout()">logout</button>
        </div>
        <router-link v-if="$route.name !== 'Login'"
        to="/favourites" event="" exact
        @click.native.prevent="checkFavouritesCount()"
        class="link-favourite px-2
        d-flex align-items-center">
          <i class="far fa-star mr-2"></i>
          <span>{{ favouritedCount.toString() }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { create } from 'vue-modal-dialogs';
import BasicDialog from '@/components/Dialogs/BasicDialog';

const dialog = create(BasicDialog, 'content');

export default {
  computed: {
    ...mapState({
      logoUrl: state => state.project.theme.logo,
      forPublic: state => state.project.forPublic,
      menuActive: state => state.ui.menuActive,
      userName: state => state.user.agent.name,
      isTouchscreen: state => state.project.isTouchscreen
    }),
    ...mapGetters({
      favouritedCount: 'floorplans/favouritedCount',
      isLoggedIn: 'user/isLoggedIn'
    }),
  },
  methods: {
    ...mapMutations({
      setMenuActive: 'ui/setMenuActive'
    }),
    ...mapActions({
      clearToken: 'user/clearToken'
    }),
    checkFavouritesCount() {
      if (this.favouritedCount > 0) {
        this.$router.push('/favourites');
      } else {
        dialog('Favourite at least one floorplan to continue.');
      }
    },
    logout() {
      this.clearToken();
      this.$router.push('/login');
      this.$toasted.show('Logout successful.', {
        theme: 'success',
        position: 'top-center',
        duration: 3000,
        type: 'success'
      });
      this.setMenuActive(false);
    }
  }
};
</script>

<style lang="scss" scoped>
#app-bar {
  // opacity: 0.3;
  background: var(--branding);
  z-index: 2000;
  position: fixed;
  bottom: 0;
  left: 0;

  #app-bar-content {
    height: $app-bar-height;

    #app-bar-logo {
      // height: $app-bar-height;
      object-fit: contain;
      object-position: left;
      // width: 150px;
      cursor: pointer;
    }
  }
}

@media screen and (max-width: $breakpoint-sm) {
  #app-bar {
    #app-bar-content {
      height: $app-bar-height-mobile;

      #app-bar-logo {
        max-width: 60%;
      }
    }
  }
}

.btn-menu {
  color: white;
  padding-left: 0;

  i {
    font-size: 2rem;
  }
}

.user-name {
  color: white;
  font-family: Scandia-Regular, sans-serif;
  border-left: 1px solid var(--text);
}

.btn-logout {
  &:hover {
    text-decoration: underline;
  }
}

.link-favourite {
  display: block;
  font-family: Scandia-Regular, sans-serif;
  border-bottom: 3px solid var(--favourite);
  color: white;
  transition: padding 0.3s ease;
  padding-bottom: 0px;
  // height: $app-bar-height;
  font-size: 1.6rem;

  &:hover {
    color: white;
    padding-bottom: 4px;
  }

  > span {
    font-size: 2rem;
  }
}

@media screen and (max-width: $breakpoint-sm) {
  .btn-menu {
    i {
      font-size: 1.5rem;
    }
  }

  .link-favourite {
    color: white;
    font-size: 1.2rem;

    &:hover {
      color: white;
      padding-bottom: 4px;
    }

    > span {
      font-size: 1.6rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppBar.vue